import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Input } from 'antd';
import TimePicker from './TimePicker';
import {numberValidation} from "../../../helper/FeildValidations";

const TimeRangePicker = ({
  endLimit,
  index,
  pickers,
  setTimePicker,
  day,
  currency,
  seatPrice,
  value = {},
  onChange,
  type,
  initialValue
}) => {
  const [startTime, setBeginTime] = useState(
    pickers.length > 1 && pickers[index - 1]?.endTime
      ? moment(pickers[index - 1].endTime, 'h:mm a')
          .add(1, 'hour')
          .format('h:mm a')
      : '7:00 am'
  );
  const [endTime, setEndTime] = useState(endLimit);
  const [pricePer, setPricePer] = useState();
  const [name, setName] = useState(null);

  useEffect(() => {
    if(initialValue?.startTime || initialValue?.endTime || initialValue?.name === day){
      setBeginTime(initialValue?.startTime);
      setEndTime(initialValue?.endTime);
      setPricePer(initialValue?.price.amount)
    }
  }, []);

  useEffect(() => {
    const time = { startTime, endTime };
    handleTimeValueChange(index, time);
  }, [startTime, endTime]);

  const handleTimeValue = (picker) => {
    const filteredList = pickers
      .filter((pick, index) => index !== picker)
      .map((timePicker, index) => {
        return timePicker;
      });
    setTimePicker(filteredList);
  };

  const handleTimeValueChange = (timeIndex, time) => {
    const filteredPickers = pickers.map((other, index) => {
      if (index === timeIndex) {
        return time;
      } else {
        return other;
      }
    });
    setTimePicker(filteredPickers);
  };

  // useEffect(() => {
  //   setPrice();
  // }, [seatPrice, currency]);

  const trigger = (changedValue) => {
    if (onChange) {
      onChange({
        startTime,
        endTime,
        name,
        ...value,
        ...changedValue,
      });
    }
  }

  const triggerChange = (changedValue) => {
    const convertedValue = parseFloat(changedValue.pricePerHour);
    if(!changedValue.pricePerHour) {
      trigger(null);
      setPricePer(null)
    }
    else if(numberValidation(convertedValue)){
      trigger(changedValue);
      setPricePer(convertedValue)
    }else{
      trigger(pricePer);

    }
  };

  const setPrice = () => {
    triggerChange({
      name: day,
      price: {
        amount: seatPrice,
        currency: currency,
        currencySymbol: currency,
      },
    });
  };

  const handleTimeChange = (value) => {
    setBeginTime(value);
    trigger({ startTime: value });
  };

  const handleEndTimeChange = (value) => {
    setEndTime(value);
    trigger({ endTime: value });

    // setTimePicker(pickerList);
  };
  return (
    <div className="start-end-wrapper xxx">
      <div className="start-end-inner-wrapper" key={index}>
        <TimePicker
          label={'Start'}
          value={startTime}
          beginLimit="6:00 am"
          onChange={(value) => handleTimeChange(value)}
          endLimit={
            endTime ? moment(endTime, 'h:mm a').add(-1, 'hour').format('h:mm a') : '10:00 pm'
          }
          name={'startTime'}
        />
        <TimePicker
          label={'End'}
          value={endTime}
          beginLimit={
            startTime ? moment(startTime, 'h:mm a').add(1, 'hour').format('h:mm a') : '7:00 am'
          }
          onChange={(value) => handleEndTimeChange(value)}
          endLimit={'11:00 pm'}
          name={'endTime'}
        />
        <Input placeholder={'Price'} type="number" onChange={e => triggerChange({
            pricePerHour: e.target.value,
              name: day,
              price: {
                amount: e.target.value,
                currency: currency,
                currencySymbol: currency,
              },
          })}
          value={pricePer} />
      </div>
    </div>
  );
};

TimeRangePicker.propTypes = {
  endLimit: PropTypes.string,
  pickers: PropTypes.array,
  setTimePicker: PropTypes.func,
};

export default TimeRangePicker;
